import { render } from "./HeaderYellow.vue?vue&type=template&id=b8bcfa96&scoped=true"
import script from "./HeaderYellow.vue?vue&type=script&lang=js"
export * from "./HeaderYellow.vue?vue&type=script&lang=js"

import "./HeaderYellow.vue?vue&type=style&index=0&id=b8bcfa96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8bcfa96"]])

export default __exports__